import { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { fetchKnitAuthSession } from '@/services/knitService';

const KnitTest = () => {
  const [token, setToken] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchToken = async (appId: string) => {
    setLoading(true);
    setError(null);
    try {
      const authToken = await fetchKnitAuthSession(appId);
      setToken(authToken);
      console.log("Token received:", authToken);
      
      // Small delay to ensure token is set
      setTimeout(() => {
        const knitAuth = document.querySelector('knit-auth');
        if (knitAuth) {
          knitAuth.setAttribute('authsessiontoken', authToken);
          console.log("Token attribute set on knit-auth element");
          
          // Find and click the trigger button
          const triggerButton = knitAuth.querySelector('[slot="trigger"]');
          if (triggerButton) {
            console.log("Trigger button found, clicking...");
            (triggerButton as HTMLButtonElement).click();
          } else {
            setError("Trigger button not found");
          }
        } else {
          setError("knit-auth element not found in DOM");
        }
      }, 300);
    } catch (err: any) {
      console.error("Error:", err);
      setError(err.message || "Failed to fetch token");
    } finally {
      setLoading(false);
    }
  };
  
  useEffect(() => {
    // Set up event listeners for knit-auth
    const knitAuth = document.querySelector('knit-auth');
    if (knitAuth) {
      const onFinish = (e: any) => {
        console.log("Integration completed:", e.detail);
      };
      
      const onClose = (e: any) => {
        console.log("Knit component closed:", e.detail);
      };
      
      knitAuth.addEventListener('onFinish', onFinish);
      knitAuth.addEventListener('onKnitClose', onClose);
      
      return () => {
        knitAuth.removeEventListener('onFinish', onFinish);
        knitAuth.removeEventListener('onKnitClose', onClose);
      };
    }
  }, []);

  return (
    <div className="container mx-auto py-10 space-y-6">
      <h1 className="text-2xl font-bold">Knit Integration Test</h1>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="border rounded-lg p-4 space-y-4">
          <h2 className="text-lg font-semibold">TeamTailor ATS</h2>
          <Button 
            onClick={() => fetchToken('teamtailor')} 
            disabled={loading}
          >
            {loading ? 'Loading...' : 'Connect TeamTailor'}
          </Button>
        </div>
        
        <div className="border rounded-lg p-4 space-y-4">
          <h2 className="text-lg font-semibold">Lever ATS</h2>
          <Button 
            onClick={() => fetchToken('lever')} 
            disabled={loading}
          >
            {loading ? 'Loading...' : 'Connect Lever'}
          </Button>
        </div>
        
        <div className="border rounded-lg p-4 space-y-4">
          <h2 className="text-lg font-semibold">Greenhouse</h2>
          <Button 
            onClick={() => fetchToken('greenhouse')} 
            disabled={loading}
          >
            {loading ? 'Loading...' : 'Connect Greenhouse'}
          </Button>
        </div>
      </div>
      
      {error && (
        <div className="bg-red-50 text-red-700 p-4 rounded-lg">
          Error: {error}
        </div>
      )}
      
      {token && (
        <div className="bg-green-50 text-green-700 p-4 rounded-lg">
          Token received successfully!
        </div>
      )}
      
      {/* The knit-auth element */}
      <div className="mt-4">
        <knit-auth>
          <button slot="trigger" style={{ display: 'none' }}>Open Knit</button>
        </knit-auth>
      </div>
    </div>
  );
};

export default KnitTest; 